module.exports = __webpack_public_path__ + "static/media/TbSettingsDollar.41ac2b8c.svg";